export enum ApiErrorType {
  ErrorSubmit = 'error_submit',
  ErrorRates = 'error_rates',
  ErrorEvent = 'error_event' // Default
}
